import { ArrowRight, CalendarClock, Check, Mail, MessageCircle } from 'lucide-react';
import { thankYouSteps } from '../data/content';
import { site } from '../data/site';
import { getLead, leadMailtoUrl, leadWhatsAppUrl } from '../lib/leads';

export function ThankYouPage() {
  const lead = getLead();
  const whatsappHref = lead ? leadWhatsAppUrl(lead) : `https://wa.me/${site.whatsappNumber}`;
  const mailHref = lead ? leadMailtoUrl(lead) : `mailto:${site.email}`;

  return (
    <main id="conteudo" className="thanks-page">
      <section className="thanks-hero">
        <div className="thanks-grid-pattern" aria-hidden="true" />
        <img className="hero-waves" src="/brand/rms-waves.svg" alt="" aria-hidden="true" />

        <div className="container thanks-layout">
          <div className="thanks-copy">
            <span className="eyebrow eyebrow--light"><span /> MENSAGEM PREPARADA</span>
            <h1>Agora confirme o envio no WhatsApp.</h1>
            <p>
              {lead
                ? `${lead.name}, sua ficha está pronta. Envie a mensagem no WhatsApp para a equipe RMS receber o pedido.`
                : 'Use o WhatsApp ou o e-mail para solicitar sua demonstração à equipe RMS.'}
              {' '}Preparar a ficha não envia os dados automaticamente nem contrata um plano.
            </p>

            {lead ? (
              <div className="thanks-protocol" aria-label="Protocolo do diagnóstico">
                <span>Protocolo</span>
                <strong>{lead.protocol}</strong>
              </div>
            ) : null}

            <ul className="thanks-checklist">
              <li><Check /> Ficha preparada neste navegador</li>
              <li><Check /> Plano e dados do escritório na mensagem</li>
              <li><Check /> Confirme o envio no WhatsApp</li>
            </ul>
          </div>

          <aside className="thanks-card">
            <span className="thanks-card-kicker">Próximo passo</span>
            <h2>Confirme a ficha no WhatsApp</h2>
            <p>
              O envio abre a conversa com a RMS já preenchida. Se a janela não abriu, use o botão abaixo.
            </p>

            <a className="button button--cyan" href={whatsappHref} target="_blank" rel="noreferrer">
              <MessageCircle /> Confirmar no WhatsApp
            </a>

            {site.calendarUrl ? (
              <a className="button button--outline" href={site.calendarUrl} target="_blank" rel="noreferrer">
                <CalendarClock /> Escolher o horário
              </a>
            ) : (
              <a className="button button--outline" href={mailHref}>
                <Mail /> Enviar por e-mail
              </a>
            )}

            {lead ? (
              <dl className="thanks-summary">
                <div><dt>Plano de interesse</dt><dd>{lead.plan || 'Quero ajuda para escolher'}</dd></div>
                <div>
                  <dt>Escritório</dt>
                  <dd>{lead.office}</dd>
                </div>
                <div>
                  <dt>Carteira</dt>
                  <dd>{lead.portfolio}</dd>
                </div>
                <div>
                  <dt>Sistema</dt>
                  <dd>{lead.system}</dd>
                </div>
              </dl>
            ) : null}
          </aside>
        </div>
      </section>

      <section className="section thanks-next">
        <div className="container">
          <h2>O que acontece agora</h2>
          <ol className="thanks-steps">
            {thankYouSteps.map((step, index) => (
              <li key={step.title}>
                <span>0{index + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
          <a className="text-link" href="/#produto">
            Voltar ao ContDesk <ArrowRight />
          </a>
        </div>
      </section>
    </main>
  );
}
